import React, { PropTypes } from "react";
import { SelectInput, TextInput } from "../../../../../common/form";
import { FormattedMessage } from "react-intl";
import categorisationSegmentationTypes from "../enums/categorisationSegmentationTypes";
import categorisationMarketSituationTypes from "../enums/categorisationMarketSituationTypes";
import { Field } from "redux-form";
import { convertBlankOptionToNull } from "../../premiumSimulator/utils";

class CategorisationFinancialFields extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            numberOfMembers: "",
        };
    }

    render() {
        const { required } = this.props;
        return (
            <div>
                <h3>
                    <FormattedMessage id="clients.client.categorisation.financialForm.title" />
                </h3>
                <div className="form-width">
                    <Field
                        id="numberOfMembers"
                        name="numberOfMembers"
                        component={TextInput}
                        disabled={true}
                        required={false}
                        label={
                            <FormattedMessage id="clients.client.categorisation.categoryForm.form.numberOfMembers" />
                        }
                    />
                    <Field
                        id="segmentation"
                        name="segmentation"
                        normalize={(value) => convertBlankOptionToNull(value)}
                        component={SelectInput}
                        required={true}
                        addBlankOption={!required}
                        blankMessageKey="common.blank"
                        options={categorisationSegmentationTypes}
                        label={<FormattedMessage id="clients.client.categorisation.financialForm.form.segmentation" />}
                    />
                    <Field
                        id="marketSituation"
                        name="marketSituation"
                        normalize={(value) => convertBlankOptionToNull(value)}
                        component={SelectInput}
                        addBlankOption={!required}
                        blankMessageKey="common.blank"
                        required={true}
                        options={categorisationMarketSituationTypes}
                        label={
                            <FormattedMessage id="clients.client.categorisation.financialForm.form.marketSituation" />
                        }
                    />
                </div>
            </div>
        );
    }
}

CategorisationFinancialFields.propTypes = {
    clientClassification: PropTypes.object,
    clientId: PropTypes.number,
    required: PropTypes.bool,
    disabled: PropTypes.bool
};

export default CategorisationFinancialFields;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/categorisation/forms/CategorisationFinancialFields.js